//@ts-nocheck
export const currencies = [
  {
    value: 'INR',
    label: 'INR',
    symbol: '₹',
  },
  {
    value: 'USD',
    label: 'USD',
    symbol: '$',
  },
  {
    value: 'EUR',
    label: 'EUR',
    symbol: '€',
  },
  {
    value: 'IDR',
    label: 'IDR',
    symbol: 'Rp',
  },
  {
    value: 'PHP',
    label: 'PHP',
    symbol: '₱',
  },
  {
    value: 'KSH',
    label: 'KSH',
    symbol: 'Ksh',
  },
  {
    value: 'AED',
    label: 'AED',
    symbol: 'د.إ',
  },
  {
    value: 'SGD',
    label: 'SGD',
    symbol: 'S$',
  },
  {
    value: 'SAR',
    label: 'SAR',
    symbol: 'SR',
  },

  {
    value: 'MYR',
    label: 'MYR',
    symbol: 'RM',
  },
  {
    value: 'MMK',
    label: 'MMK',
    symbol: 'K',
  },
  {
    value: 'BDT',
    label: 'BDT',
    symbol: '৳',
  },
  {
    value: 'NPR',
    label: 'NPR',
    symbol: 'Rs',
  },
  {
    value: 'SLR',
    label: 'SLR',
    symbol: 'Rs',
  },
  {
    value: 'GBP',
    label: 'GPB',
    symbol: '£',
  },
  {
    value: 'CAD',
    label: 'CAD',
    symbol: 'Can$',
  },
  {
    value: 'HKD',
    label: 'HKD',
    symbol: 'HK$',
  },
] as const;
